import React from 'react';

import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import styles from './GameObjectives.scss';

const GameObjectives = ({ slug, messageIds }) => {
  return (
    <div className="GameObjectives">
      <header className="GameObjectives__header">
        <h4 className="GameObjectives__header-text">
          <ConnectedFormattedMessage id="game_objectives.title" />
        </h4>
      </header>
      <ul className="GameObjectives__items">
        {messageIds.map((id, i) => (
          <li className="GameObjectives__item" key={`objective-${i}`}>
            <ConnectedFormattedMessage id={id} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default GameObjectives;
